import ZkKvLine from './src/main'
ZkKvLine.install = function(Vue) {
  Vue.component(ZkKvLine.name, ZkKvLine)
}
export default ZkKvLine



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/kvLine/index.js